import { frontendURL } from '../../../helper/URLHelper';

import LiaAgentsLayout from './pages/LiaAgentsLayout.vue';
import LiaAgentsList from './pages/LiaAgentsList.vue';
import LiaAgentCreate from './pages/LiaAgentCreate.vue';
// Simplified edit component (original: LiaAgentEdit.vue - 3324 lines)
import LiaAgentEdit from './pages/LiaAgentEditSimplified.vue';
import LiaAgentWizard from './pages/LiaAgentWizard.vue';
import LiaIntegrations from './pages/LiaIntegrations.vue';

const meta = {
  permissions: ['administrator'],
};

const liaAgentRoutes = [
  {
    path: '',
    name: 'lia_agents_list',
    component: LiaAgentsList,
    meta,
  },
  {
    path: 'wizard',
    name: 'lia_agents_wizard',
    component: LiaAgentWizard,
    meta,
  },
  {
    path: 'new',
    name: 'lia_agents_create',
    component: LiaAgentCreate,
    meta,
  },
  {
    path: ':agentId/edit',
    name: 'lia_agents_edit',
    component: LiaAgentEdit,
    meta,
  },
  {
    path: 'integrations',
    name: 'lia_integrations',
    component: LiaIntegrations,
    meta,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/lia-agents'),
    component: LiaAgentsLayout,
    redirect: to => ({
      name: 'lia_agents_list',
      params: to.params,
    }),
    children: liaAgentRoutes,
  },
];

export default { routes };
